export default "__VITE_ASSET__Bb36yzZu__"